import React from 'react';
import { loadInventories } from '../Inventory/Helper';
import { BasicDataTable } from '../../components/DataTable';
import { ErrorToastComponent as ErrorToast  } from '../../components/Toasts';

class InventoryListPage extends React.Component {
    constructor(props) {
        super();
        this.state = {
            datatable: {
                columns: [
                    {
                        label: 'Item Name',
                        field: 'inventory_name',
                        width: 150
                    },
                    {
                        label: 'Description',
                        field: 'description'
                    },
                    {
                        label: 'Quantity',
                        field: 'quantity'
                    },
                    {
                        label: 'Action',
                        field: 'product_action'
                    }
                ],
                rows: []
            }
        }
    }

    async componentDidMount() {
        try {

            // load sites
            await this.loadAvailableItems();

        } catch(err) {
            throw new Error(err.message);
        }
    }

    async loadAvailableItems() {
        try {

            const self = this;
            const inventory = await loadInventories();

            const productRows = [];
            for(const itemInfo of inventory) {
                if(itemInfo.item) {
                    const product = {
                        inventory_name: itemInfo.item.inventory_name,
                        description: itemInfo.item.description ?? 'No description available',
                        quantity: itemInfo.item.quantity,
                        shippable: itemInfo.item.shippable ? 'Yes' : 'No',
                        product_action: self.itemActions(itemInfo.item.inventory_id)
                    };
                    productRows.push(product);
                }
            }
        
            self.setState({
                datatable: {
                    columns: self.state.datatable.columns,
                    rows: productRows
                }
            });

        } catch(err) {
            throw new Error(err.message);
        }
    }

    redirectItemPage(itemID) {
        try {
            const path = `/inventory?screen=dashboard&inventory_id=${itemID}`;
            window.location.href = path;
            return;
        } catch(err) {
            throw new Error(err.message);
        }
    }

    transferItemPage(itemID) {
        try {
            const path = `/inventory?screen=transfer&inventory_id=${itemID}`;
            window.location.href = path;
            return;
        } catch(err) {
            throw new Error(err.message);
        }
    }

    updateStockPage(itemID) {
        try {
            const path = `/inventory?screen=updatestock&inventory_id=${itemID}`;
            window.location.href = path;
            return;
        } catch(err) {
            throw new Error(err.message);
        }
    }

    itemActions(itemID) {
        try {
            return (
                <>
                    <button className="btn btn-info btn-circle btn-sm" data-toggle="tooltip" title='Check Product Information' onClick={() => this.redirectItemPage(itemID)}>
                        <i className="fas fa-info-circle"></i>
                    </button>
                    <button className="btn btn-danger btn-circle btn-sm margin-left-10" data-toggle="tooltip" title='Transfer Inventory' onClick={() => this.transferItemPage(itemID)}>
                        <i class="fas fa-exchange-alt"></i>
                    </button>
                    <button className="btn btn-success btn-circle btn-sm margin-left-10" data-toggle="tooltip" title='Transfer Inventory' onClick={() => this.updateStockPage(itemID)}>
                        <i class="fas fa-sort-numeric-up"></i>
                    </button>
                </>
            );
        } catch(err) {
            throw new Error(err.message);
        }
    }

    async createNewItem() {
        try {
            window.location.href = '/shop?screen=addnew';
            return;
        } catch(err) {
            throw new Error(err.message);
        }
    }

    addProductButton() {
        try {
            return (
                <button className="btn btn-success btn-circle btn-sm add-token-btn" data-toggle="tooltip" title='Create new product' onClick={this.createNewProduct}>
                    <i className="far fa-plus-square"></i>
                </button>
            )
        } catch(err) {
            throw new Error(err.message);
        }
    }

    renderTable() {
        try {
            let table = 'No items available';
            if(this.state.datatable.rows.length > 0) {
                table = <BasicDataTable label='Available Items' data={this.state.datatable} />;
            }

            return (
                
                <div className="card shadow mb-4">
                    <div className="card-header py-3">
                        <h6 className="m-0 font-weight-bold text-primary">Available Items</h6>
                        {this.addProductButton()}
                    </div>
                    <div className="card-body">
                        {table}
                    </div>
                </div>
            );
        } catch(err) {
            throw new Error(err.message);
        }
    }

    pageContent() {
        try {
            return (
                <>
                    {this.renderTable()}
                </>
            )
        } catch(err) {
            throw new Error(err.message);
        }
    }

    render() {
        return (
            <>  
                <div class='container'>
                    {this.pageContent()}
                    <ErrorToast message={this.state.err_message}/>
                </div>
            </>
        );
    }
}

export default InventoryListPage;